import {Component, Input} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ReportService} from '../../../../services/report.service';
import {saveAs} from 'file-saver';
import {NotificationService} from '../../../../services/notification.service';
import {ReportStatusDTO} from '../../../../model/reportStatusDTO';
import {UserService} from '../../../../services/user.service';
import {ConfirmDTO} from '../../../shared/notification/ConfirmDTO';
import {FinishedReportDTO} from '../../../../model/finishedReportDTO';

@Component({
  selector: 'app-report-list-item',
  templateUrl: './report-list-item.component.html',
})
export class ReportListItemComponent {

  @Input() reports: ReportStatusDTO[] = [];
  @Input() clientId: number;

  constructor(private router: Router,
              private notificationService: NotificationService,
              private route: ActivatedRoute,
              public reportService: ReportService,
              public userService: UserService,
              private translate: TranslateService) {
    translate.use('nl');
  }

  open(report: ReportStatusDTO): void {
    this.router.navigate(this.reportService.getReportUrl(this.clientId, report.code, report.year));
  }

  download(finishedReport: FinishedReportDTO, report: ReportStatusDTO) {
    this.reportService.downloadFinishedReport(finishedReport.id).subscribe((data) => {
      saveAs(data, this.reportService.reportFileNameOf(report.code, report.year, true));
      this.notificationService.success('rapport gedownload');
    });
  }

  undoFinished(report: ReportStatusDTO) {
    const dto: ConfirmDTO = {header: 'rapport definitief ongedaan maken'};
    this.notificationService.confirm(dto).then(() =>
      this.reportService.undoFinished(this.clientId, report.code, report.year).subscribe(() => {
        this.notificationService.success('rapport ongedaan gemaakt');
        report.finished = null;
        report.finishedAt = null;
      })
    );
  }

  openOtherTransactions(report: ReportStatusDTO) {
    this.reportService.getReportMetaData(report.code, this.clientId, report.year)
      .subscribe(metadata => {
        this.router.navigate(['/bewind/' + this.clientId + '/overige-inkomsten-en-uitgaven/' + metadata.id]);
      });
  }
}
